import { render, staticRenderFns } from "./DenseInterfaceToolbarElementInterfaceFactsLights.vue?vue&type=template&id=8f2a3c68&scoped=true&"
import script from "./DenseInterfaceToolbarElementInterfaceFactsLights.vue?vue&type=script&lang=ts&"
export * from "./DenseInterfaceToolbarElementInterfaceFactsLights.vue?vue&type=script&lang=ts&"
import style0 from "./DenseInterfaceToolbarElementInterfaceFactsLights.vue?vue&type=style&index=0&id=8f2a3c68&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2a3c68",
  null
  
)

export default component.exports